import { render, staticRenderFns } from "./autotest.vue?vue&type=template&id=080dff96&"
import script from "./autotest.vue?vue&type=script&lang=js&"
export * from "./autotest.vue?vue&type=script&lang=js&"
import style0 from "./autotest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports